import { Modal, Stack, IconButton, Typography } from "@mui/material";
import { ContentModal } from "components/Surfaces/ContentModal/ContentModal";
import CloseIcon from "@mui/icons-material/Close";
import CondominioService from "services/condominio";
import dayjs from "dayjs";

export default function ModalProtocolReconnect({
  open,
  onClose,
  data,
  onCancel,
}) {
  if (!open || !data) return null;

  const { endereco } = CondominioService.selected || {};

  function parseInfo(infoStr = "") {
    return infoStr
      .split("\n")
      .map((l) => l.trim())
      .filter(Boolean)
      .reduce((acc, line) => {
        let key, value;

        if (line.includes(":")) {
          const [rawKey, ...rest] = line.split(":");
          key = rawKey.trim();
          value = rest.join(":").trim();
        } else if (line.includes("? ")) {
          const cut = line.lastIndexOf("? ");
          key = line.slice(0, cut + 1).trim();
          value = line.slice(cut + 2).trim();
        } else {
          key = line;
          value = "";
        }

        if (key) acc[key] = value;
        return acc;
      }, {});
  }

  const parsedInfo = parseInfo(data["informacoes"] ?? "");

  return (
    <Modal open={open} onClose={onClose} disableAutoFocus disableEnforceFocus>
      <ContentModal
        minWidth={"816px"}
        style={{ width: "auto" }}
        borderRadius={"8px"}
      >
        <Stack p={"30px 40px"}>
          <Stack
            direction={"row"}
            justifyContent={"flex-end"}
            alignItems={"center"}
          >
            <IconButton onClick={onClose}>
              <CloseIcon
                sx={{
                  color: "#053462",
                  fontSize: "31px",
                }}
              />
            </IconButton>
          </Stack>
          <Typography
            fontSize={"30px"}
            fontWeight={800}
            fontStyle={"italic"}
            color="#3A3A3A"
            mt={"18px"}
          >
            {data.assunto}
          </Typography>
          {data.cancela ? (
            <Typography
              fontSize={"18px"}
              fontWeight={700}
              color="#3A3A3A"
              mt={"8px"}
            >
              Protocolo: {data["nr-ordem-servico"]}
            </Typography>
          ) : (
            <>
              <Typography mt={"8px"} fontWeight={700} fontSize={"20px"}>
                Cancelado
              </Typography>
              <Typography fontSize={"15px"} fontWeight={500} color="#3A3A3A">
                Protocolo: {data["nr-ordem-servico"]}
              </Typography>
            </>
          )}

          <Stack mt={"24px"} gap={"11px"}>
            {!data.cancela && (
              <>
                <Typography
                  fontSize={"20px"}
                  fontWeight={700}
                  color="#3A3A3A"
                  fontStyle={"italic"}
                >
                  Valor do serviço
                </Typography>
                <Typography fontSize={"15px"} fontWeight={500} color="#3A3A3A">
                  R$ 0,00
                </Typography>
              </>
            )}
            <Typography
              fontSize={"20px"}
              fontWeight={700}
              color="#3A3A3A"
              fontStyle={"italic"}
            >
              Data da contratação
            </Typography>
            <Typography fontSize={"15px"} fontWeight={500} color="#3A3A3A">
              {dayjs(data["dt-ordem-servico"]).format("DD/MM/YYYY")}
            </Typography>
            <Typography
              fontSize={"20px"}
              fontWeight={700}
              color="#3A3A3A"
              fontStyle={"italic"}
            >
              Data máxima para atendimento
            </Typography>
            <Typography fontSize={"15px"} fontWeight={500} color="#3A3A3A">
              {dayjs(data["dt-prev-atend"]).format("DD/MM/YYYY")}
            </Typography>
          </Stack>
          <Stack mt={"24px"} borderTop={"1.5px solid #B7B7B7"}>
            {!data.cancela && (
              <>
                <Typography
                  fontSize={"20px"}
                  fontWeight={700}
                  color="#3A3A3A"
                  fontStyle={"italic"}
                  mt={"24px"}
                >
                  Detalhamento do cancelamento
                </Typography>

                <Typography
                  fontSize={"16px"}
                  fontWeight={700}
                  color="#3A3A3A"
                  mt={"24px"}
                >
                  Observações:
                </Typography>
                <Typography fontSize={"15px"} fontWeight={500} color="#3A3A3A">
                  {data.motivo}
                </Typography>
              </>
            )}
            <Typography
              fontSize={"20px"}
              fontWeight={700}
              color="#3A3A3A"
              fontStyle={"italic"}
              mt={"24px"}
            >
              Detalhamento do{" "}
              {data.assunto === "Religação de gás" ? "religue" : "corte de gás"}
            </Typography>

            {data.assunto === "Religação de gás" && (
              <>
                <Typography
                  fontSize={"16px"}
                  fontWeight={700}
                  color="#3A3A3A"
                  mt={"24px"}
                >
                  Já existe algum medidor instalado no local?
                </Typography>
                <Typography fontSize={"15px"} fontWeight={500} color="#3A3A3A">
                  Sim
                </Typography>
              </>
            )}

            {data.assunto === "Corte de gás por cancelamento de cadastro" && (
              <>
                <Typography
                  fontSize={"16px"}
                  fontWeight={700}
                  color="#3A3A3A"
                  mt={"24px"}
                >
                  Qual data deixará o imóvel?
                </Typography>
                <Typography fontSize={"15px"} fontWeight={500} color="#3A3A3A">
                  {parsedInfo["Dt Saída Apto"]}
                </Typography>
              </>
            )}

            <Typography
              fontSize={"16px"}
              fontWeight={700}
              color="#3A3A3A"
              mt={"10px"}
            >
              Seu condomínio tem porteiro?
            </Typography>
            <Typography fontSize={"15px"} fontWeight={500} color="#3A3A3A">
              {parsedInfo["Seu condomínio tem porteiro?"]}
            </Typography>
            {parsedInfo["Seu condomínio tem porteiro?"] === "Nao" && (
              <>
                <Typography
                  fontSize={"16px"}
                  fontWeight={700}
                  color="#3A3A3A"
                  mt={"10px"}
                >
                  Como o técnico poderá acessar o local para realizar o
                  atendimento?
                </Typography>
                <Typography fontSize={"15px"} fontWeight={500} color="#3A3A3A">
                  {parsedInfo["Nome de quem receberá o técnico"]?.trim()
                    ? "Outra pessoa estará no local para receber o técnico"
                    : parsedInfo["Outras formas de acesso"]?.trim()
                    ? "Outras formas de acesso"
                    : "Estarei no local para receber o técnico"}
                </Typography>
              </>
            )}

            {parsedInfo["Nome de quem receberá o técnico"]?.trim() && (
              <>
                <Typography
                  fontSize={"20px"}
                  fontWeight={700}
                  color="#3A3A3A"
                  fontStyle={"italic"}
                  mt={"24px"}
                >
                  Quem irá receber o técnico?
                </Typography>
                <Typography
                  fontSize={"16px"}
                  fontWeight={700}
                  color="#3A3A3A"
                  mt={"24px"}
                >
                  Nome:
                </Typography>
                <Typography fontSize={"15px"} fontWeight={500} color="#3A3A3A">
                  {parsedInfo["Nome de quem receberá o técnico"]}
                </Typography>
                <Typography
                  fontSize={"16px"}
                  fontWeight={700}
                  color="#3A3A3A"
                  mt={"10px"}
                >
                  Telefone:
                </Typography>
                <Typography fontSize={"15px"} fontWeight={500} color="#3A3A3A">
                  {parsedInfo["Contato de quem receberá o técnico"]}
                </Typography>
              </>
            )}

            {parsedInfo["Outras formas de acesso"]?.trim() && (
              <>
                <Typography
                  fontSize={"20px"}
                  fontWeight={700}
                  color="#3A3A3A"
                  fontStyle={"italic"}
                  mt={"24px"}
                >
                  Como o técnico irá acessar o local?
                </Typography>
                <Typography
                  fontSize={"16px"}
                  fontWeight={700}
                  color="#3A3A3A"
                  mt={"24px"}
                >
                  Detalhe do acesso:
                </Typography>
                <Typography fontSize={"15px"} fontWeight={500} color="#3A3A3A">
                  {parsedInfo["Outras formas de acesso"]}
                </Typography>
              </>
            )}

            <Typography
              fontSize={"20px"}
              fontWeight={700}
              color="#3A3A3A"
              fontStyle={"italic"}
              mt={"24px"}
            >
              Informações do cliente
            </Typography>
            <Typography
              fontSize={"16px"}
              fontWeight={700}
              color="#3A3A3A"
              mt={"24px"}
            >
              Nome:
            </Typography>
            <Typography fontSize={"15px"} fontWeight={500} color="#3A3A3A">
              {parsedInfo["Contato"]}
            </Typography>

            <Typography
              fontSize={"16px"}
              fontWeight={700}
              color="#3A3A3A"
              mt={"10px"}
            >
              Sobrenome ou Departamento:
            </Typography>
            <Typography fontSize={"15px"} fontWeight={500} color="#3A3A3A">
              {parsedInfo["Sobrenome ou Departamento"]}
            </Typography>
            <Typography
              fontSize={"16px"}
              fontWeight={700}
              color="#3A3A3A"
              mt={"10px"}
            >
              Telefone:
            </Typography>
            <Typography fontSize={"15px"} fontWeight={500} color="#3A3A3A">
              {parsedInfo["Telefone"]}
            </Typography>
            <Typography
              fontSize={"16px"}
              fontWeight={700}
              color="#3A3A3A"
              mt={"10px"}
            >
              Email:
            </Typography>
            <Typography fontSize={"15px"} fontWeight={500} color="#3A3A3A">
              {parsedInfo["E-mail"]}
            </Typography>
            <Typography
              fontSize={"16px"}
              fontWeight={700}
              color="#3A3A3A"
              mt={"10px"}
            >
              Endereço:
            </Typography>
            <Typography fontSize={"15px"} fontWeight={500} color="#3A3A3A">
              {endereco}
            </Typography>
            <Typography
              fontSize={"16px"}
              fontWeight={700}
              color="#3A3A3A"
              mt={"10px"}
            >
              Condomínio:
            </Typography>
            <Typography fontSize={"15px"} fontWeight={500} color="#3A3A3A">
              {parsedInfo["Nome Condomínio"]}
            </Typography>
            <Typography
              fontSize={"16px"}
              fontWeight={700}
              color="#3A3A3A"
              mt={"10px"}
            >
              Apto/Bloco:
            </Typography>
            <Typography fontSize={"15px"} fontWeight={500} color="#3A3A3A">
              {parsedInfo["Bloco / Apto"]}
            </Typography>
          </Stack>
        </Stack>

        {data.cancela && (
          <Stack
            justifyContent={"center"}
            alignItems={"center"}
            mt={"24px"}
            bgcolor={"#F5F5F5"}
            p={"29px"}
            sx={{
              cursor: "pointer",
            }}
            onClick={onCancel}
          >
            <Typography fontWeight={600} color="#0A0A0A">
              CANCELAR PEDIDO
            </Typography>
          </Stack>
        )}
      </ContentModal>
    </Modal>
  );
}
